import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import {Container,Row,Col} from "reactstrap";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import moment from "moment";
import {formatDateForBottomBar, getWeekdayFromDate} from "../../DateHelper";
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import "../../vodafone.css"
import MomentLocaleUtils from 'react-day-picker/moment';
import 'moment/locale/de';
import {SpacerRow} from "../../components/SpacerRow";
import SubPageTopBar from "../../components/SubPageTopBar";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import TextField from '@material-ui/core/TextField';
import vodafoneLogo from "../../media/icons/vf-logo.png";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

class StageAppointmentSelectCalendar extends React.Component {

    constructor(props){
        super(props);
        
		this.handleDayClick = this.handleDayClick.bind(this);
		
        // set first available date for calendar display

            let firstAvailableDate;
            // use changedDate as firstAvailableDate if given and customerStatus is NOT checked or available (in TT stage; see #389)
            if(props.ds360APIResult && props.ds360APIResult.changedDate && props.ds360APIResult.customerStatus !== "checked" && props.ds360APIResult.customerStatus !== "available"){
                firstAvailableDate = new Date(props.ds360APIResult.changedDate)

            // use first date in availableDates API response array
            } else if(props.availableDates){
                firstAvailableDate = new Date(props.availableDates[0])

            // else: use current date
            } else{
                firstAvailableDate = new Date()
            }
            // console.log( "FNX: firstAvailableDate=");
            // console.log( firstAvailableDate );

        this.initialMonth = firstAvailableDate;

        this.state = {
        	// do not pre-select a date
            // selectedDate: firstAvailableDate,
            selectedDate: '',
            selectedTime: '',
            locale: 'de',
			redButtonDisabled: true,
			bottomBar: ''
        };
    }

	/**
	 * handles radio button on change
	 * enables submit button is one of the options is selected
	 * @param e
	 */
    handleOnChange = (e) =>  {
        console.log('selected option', e.target.value);
        this.setState({ selectedTime: e.target.value});
        this.setState({ selectedOption: e.target.value});
		// activate Button
		this.state.redButtonDisabled = false;
    }

	/**
	 * handles the selection of one day in the calendar
	 * @param day
	 * @param selected
	 * @param disabled
	 */
    handleDayClick(day, { selected, disabled }) {
        if(disabled === true){
            return;
        }
        this.setState({
            selectedDate: selected ? undefined : day,
        });
    }

	/**
	 * render
	 * @returns {*}
	 */
	render() {

		/**
		 * bottomBar setzen
		 */
		if(this.state.selectedDate){
            const proposalDate = moment(this.props.ds360APIResult.proposalDate);
        	const isoSelectedDate = moment(this.state.selectedDate)
                        .set("hours", proposalDate.get("hours"))
                        .set("minutes", proposalDate.get("minutes"))
                        .toISOString(false);
        	this.state.bottomBar = <BottomBar
                mainButtonOnClick={() => {

                	// build selected date in iso format and call calendarSelectCallback
                    var momentHours = parseInt( this.state.selectedTime.substr(0,2) );
                    var momentMinutes = parseInt( this.state.selectedTime.substr(3,2) );
                    const isoSelectedDate = moment.utc(this.state.selectedDate)
                        .set("hours", momentHours)
                        .set("minutes", momentMinutes)
                        .toISOString(false);
					// console.log( "FNX: AppointmentSelectCalendar.js // mainButtonOnClick // this.state.selectedTime: " + this.state.selectedTime );
					// console.log( "FNX: AppointmentSelectCalendar.js // mainButtonOnClick // momentHours: " + momentHours );
					// console.log( "FNX: AppointmentSelectCalendar.js // mainButtonOnClick // isoSelectedDate: " + isoSelectedDate );
                    this.props.calendarSelectCallback(isoSelectedDate)

                }}
                mainButtonTextResource={"continue"}
                weekday={
                    getWeekdayFromDate(this.state.selectedDate)
                }
                date={
                    formatDateForBottomBar(this.state.selectedDate)
                }
				disabled={this.state.redButtonDisabled}
            />;
	        // console.log( "FNX: stage2-AppointmentSelectCalendar.js bottomBar / mainButtonOnClick / this.state.selectedDate: "); console.log( this.state.selectedDate );
	        // console.log( "FNX: stage2-AppointmentSelectCalendar.js bottomBar / mainButtonOnClick / this.props.ds360APIResult.proposalDate: "); console.log( this.props.ds360APIResult.proposalDate );
	        // console.log( "FNX: stage2-AppointmentSelectCalendar.js bottomBar / mainButtonOnClick / proposalDate.get(\"hours\"): "); console.log( proposalDate.get("hours") );
	        // console.log( "FNX: stage2-AppointmentSelectCalendar.js bottomBar / mainButtonOnClick / isoSelectedDate: "); console.log( isoSelectedDate );
        }

		/**
		 * Kalender-Datepicker erzeugen
		 */
		const calendarPickerContent = <div>
            <SpacerRow/>
            <Header
                textResource={"tam6000_calendar_title"}
            />
            <SpacerRow/>
			<Row>
				<Col xs={{ size: 5 }} className={"onlyDesktop"}>
					<DayPicker
						className={"width-100"}
						localeUtils={MomentLocaleUtils}
						locale={this.state.locale}
						showOutsideDays={true}
						selectedDays={this.state.selectedDate}
						initialMonth={this.initialMonth}
						disabledDays={
							[
								{ daysOfWeek: [0, 6] },
								(day) => {
									const dayMoment = moment(day).format("YYYY-MM-DD");
									return (this.props.availableDates.indexOf(dayMoment) === -1)
								}
							]
						}
						onDayClick={this.handleDayClick}
					/>
				</Col>
			</Row>
			<SpacerRow/>
        </div>;

        return <Container fluid={true} style={{backgroundColor:"white",height:"150%"}}>

			<MobileView>
                <Row className={"header"}>
					<Col xs={2} style={{marginLeft:"-15px"}}>
						<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
					</Col>
				</Row>
				{calendarPickerContent}
                <span>
                    <Row className={'fixed-to-bottom'}>
					<Col xs={{ size: 12 }}>
					<Row>
						<Col xs={12} className={this.state.selectedDate ? "timepicker-show" : "timepicker-hide"}>
							<FormControl className={"width-100 calendar myRadioGroup"}>
								<RadioGroup>
									<FormControlLabel
										value="08:00" control={<Radio />} onChange={this.handleOnChange} label="Vormittags 8-13 Uhr"
									className={ `${this.state.selectedOption === "08:00" ? 'radio_active' : 'radio_inactive'}` }>
									</FormControlLabel>
									<FormControlLabel
										value="12:00" control={<Radio />} onChange={this.handleOnChange} label="Nachmittags 12-17 Uhr"
									className={ `${this.state.selectedOption === "12:00" ? 'radio_active' : 'radio_inactive'}` }>
									</FormControlLabel>
								</RadioGroup>
							</FormControl>
						</Col>
					</Row>
					{this.state.bottomBar}
					<TextField
						id={"benachrichtigungPer"}
						type={"hidden"}
						value={this.props.benachrichtigungPer}
					/>
					</Col>
					</Row>
				</span>
            </MobileView>

            <BrowserView>
                <Container>
                    <Row className={"header desktop"}>
						<Col xs={12}>
							<div className={"container"}>
								<Row>
									<Col xs={2} style={{marginLeft:"-7px"}}>
										<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
									</Col>
								</Row>
							</div>
						</Col>
                    </Row>
					<Row style={{paddingTop:"17vh"}}>
                        <Col xs={{ size: 10, offset: 1 }}>
                            {calendarPickerContent}
							<Row>
								<Col xs={12} className={this.state.selectedDate ? "timepicker-show" : "timepicker-hide"}>
									<FormControl className={"width-100 calendar myRadioGroup"}>
										<RadioGroup>
											<FormControlLabel
												value="08:00" control={<Radio />} onChange={this.handleOnChange} label="Vormittags 8-13 Uhr"
											className={ `${this.state.selectedOption === "08:00" ? 'radio_active' : 'radio_inactive'}` }>
											</FormControlLabel>
											<FormControlLabel
												value="12:00" control={<Radio />} onChange={this.handleOnChange} label="Nachmittags 12-17 Uhr"
											className={ `${this.state.selectedOption === "12:00" ? 'radio_active' : 'radio_inactive'}` }>
											</FormControlLabel>
										</RadioGroup>
									</FormControl>
								</Col>
							</Row>
							<Row>
							<Col xl={{ size: 2, offset: 0 }} lg={{ size: 3, offset: 0 }} md={{ size: 4, offset: 0 }} sm={{ size: 6, offset: 0 }} xs={{ size: 12, offset: 0 }} >
								{this.state.bottomBar}
								<TextField
									id={"benachrichtigungPer"}
									type={"hidden"}
									value={this.props.benachrichtigungPer}
								/>
								</Col>
							</Row>
                        </Col>
                    </Row>
                </Container>
            </BrowserView>

        </Container>
    }
}

export default translate("translations")(StageAppointmentSelectCalendar);